module.exports = __webpack_public_path__ + "img/illuminati.e9705c94.svg";